var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function HeartFilledIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 4.52779C13.0615 3.57771 14.4633 3 16 3C19.3137 3 22 5.68629 22 9C22 13.8362 16.994 18.5 12.4246 21.2363C12.1924 21.3809 11.8112 21.3828 11.5783 21.2383C6.97858 18.511 2 13.8365 2 9C2 5.68629 4.68629 3 8 3C9.53671 3 10.9385 3.57771 12 4.52779Z", fill: "" })));
}
export var HeartFilledIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: HeartFilledIconInner }, props))); };
//# sourceMappingURL=HeartFilledIcon.js.map